import { AppAccent } from 'src/app/core/types/app-accent.type';
import { AppVisualContextService } from 'src/app/shared/services/app-visual-context.service';
import { HostBinding, inject, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FileService } from '../../services/file.service';
import { take } from 'rxjs';
import { Arquivo, ContextoLeituraArquivo } from 'src/app/core/models/arquivo.model';
import { PopupService } from '../../services/popup.service';
import { SgrResponse } from 'src/app/core/models/response.model';

@Component({
  selector: 'app-file-download-link',
  templateUrl: './file-download-link.component.html',
  styleUrls: ['./file-download-link.component.css'],
})
export class FileDownloadLinkComponent implements OnInit, OnDestroy {
  @Input() accent?: AppAccent;
  private readonly visualContext = inject(AppVisualContextService);
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForInputs(this.accent);
  }
  @Input({ required: true }) file: Arquivo;
  @Input() contextoLeitura?: ContextoLeituraArquivo;

  showHover = false;
  showStatusMenu = false;
  private hoverTimeout: any;

  constructor(
    private fileService: FileService,
    private popupService: PopupService
  ) {}

  ngOnInit(): void {}

  buscaArquivo(arquivo: Arquivo): void {
    this.fileService.buscaArquivo(arquivo, this.contextoLeitura);
  }

  onEnterWrapper(): void {
    // Cancelar timeout se existir
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    this.showHover = true;
  }

  onLeaveWrapper(): void {
    // Delay para permitir transição suave entre elementos
    this.hoverTimeout = setTimeout(() => {
      this.showHover = false;
      this.showStatusMenu = false;
    }, 150);
  }

  openStatusMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.showStatusMenu = true;
  }

  setStatus(validated: boolean): void {
    if (this.contextoLeitura?.historico) return;
    this.file.VALIDACAO = validated ? 'VALIDO' : 'INVALIDO';

    let jsonArquivo = JSON.stringify({
      codarquivo: this.file.CODARQUIVO,
      validacao: this.file.VALIDACAO,
    });
    this.fileService
      .updateArquivo({ body: jsonArquivo })
      .pipe(take(1))
      .subscribe({
        next: (result: SgrResponse) => {
          if (!result['error']) {
            this.showSuccessFeedback(validated);
          }
        },
        error: err => {
          console.error(err);
          this.popupService.showError('Erro ao atualizar arquivo! Contate o suporte.');
        },
      });

    this.closeMenus();
  }

  getStatusClass(): string {
    if (this.file.VALIDACAO === 'VALIDO') {
      return 'mdi-check-circle status-validado';
    } else if (this.file.VALIDACAO === 'INVALIDO') {
      return 'mdi-close-circle status-nao-validado';
    } else {
      return 'mdi-help-circle-outline status-null';
    }
  }

  private closeMenus(): void {
    this.showStatusMenu = false;
    this.showHover = false;

    // Limpar qualquer timeout pendente
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  private showSuccessFeedback(validated: boolean): void {
    this.popupService.showSuccess(`Arquivo marcado como ${validated ? 'validado' : 'não validado'}!`);
  }

  ngOnDestroy(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }
}
